module.exports = "/images/Ireland.png?6b562cefc66203eba4c5c4c44d44113a";